import React, { useState, useEffect } from "react"
import { useIntl } from "react-intl"
import { Typeahead } from "react-bootstrap-typeahead"

const SearchSelect = ({ fieldName, labelKey, selected, options, onChange, disabled, multiple, placeholder, autoSelectOn4Digits = false, required = false, className }) => {
    const intl = useIntl()

    const getInitialSelection = () => {
        const list = Array.isArray(options) ? options : [];
        if (multiple) {
            const selectedArray = Array.isArray(selected) ? selected : [];
            return list.filter((option) => selectedArray.includes(option.id || option._id));
        } else {
            const selectedOption = list.find((option) => (option.id || option._id) === selected);
            return selectedOption ? [selectedOption] : [];
        }
    }

    const [selectedOptions, setSelectedOptions] = useState(getInitialSelection)

    useEffect(() => {
        setSelectedOptions(getInitialSelection())
    }, [selected, options])

    const handleSelectionChange = (selectedOption) => {
        const value = multiple 
            ? selectedOption.map((item) => item.id || item._id) 
            : (selectedOption.length > 0 ? (selectedOption[0].id || selectedOption[0]._id) : "");
        
        onChange({ target: { name: fieldName, value: value } });
        setSelectedOptions(selectedOption);
    }

    const handleInputChange = (text) => {
        onChange({ target: { name: fieldName, value: text, isTyping: true } });

        if (autoSelectOn4Digits && !multiple && text.length === 4 && !isNaN(text)) {
            const matchingOption = options.find(option => (option.id || option._id) === text || option.name === text);
            if (matchingOption) handleSelectionChange([matchingOption]);
        }
    }


    const isInvalid = (required && selectedOptions.length === 0) || (className && className.includes('is-invalid'));

    return (
        <Typeahead
            clearButton
            id={fieldName || "searchSelectTypeahead"}
            labelKey={labelKey || "name"}
            onChange={handleSelectionChange}
            onInputChange={handleInputChange}
            options={options}
            placeholder={placeholder ? (intl.messages[placeholder] ? intl.formatMessage({ id: placeholder }) : placeholder) : intl.formatMessage({ id: "textClickSelect" })}
            selected={selectedOptions}
            disabled={!!disabled}
            multiple={!!multiple}
            isInvalid={isInvalid}
            inputProps={{ 
                className: className,
                autoComplete: 'off',
                style: (isInvalid && selectedOptions.length === 0) ? { 
                    borderColor: '#dc3545',
                    boxShadow: '0 0 0 0.25rem rgba(220, 53, 69, 0.25)', 
                    backgroundImage: `url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='%23dc3545'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23dc3545' stroke='none'/%3e%3c/svg%3e")`,
                } : {}
            }}
        />
    )
}

export default SearchSelect